<mm-cash-balance
      *ngFor="let balance of balances"
      [balance]="balance"
      [formerTdaIndicator]="formerTdaIndicator">
</mm-cash-balance>
